import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'
import { mdiFacebook, mdiImageOutline, mdiInstagram, mdiLink, mdiTwitter, mdiYoutube } from '@mdi/js'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import store from '@/store'
import { useImage } from '@/shared/composables/image'
import OrganizationAbout from '@/modules/Organizations/components/info/OrganizationAbout.vue'
import OrganizationEvents from '@/modules/Organizations/components/info/OrganizationEvents.vue'
import OrganizationMedia from '@/modules/Organizations/components/info/OrganizationMedia.vue'
import OrganizationMembers from '@/modules/Organizations/components/info/OrganizationMembers.vue'
import { Organization, OrganizationTabsInfo } from '@/modules/Organizations/types'
import { fetchOrganization, updateOrganization } from '@/enitites/organization/api/endpoints'


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganizationPage',
  setup(__props) {

const { saveImage, getOrgImage } = useImage()

const route = useRoute()
const router = useRouter()

const org = ref<Organization>()
const isExpansionPanelOpen = ref(false)
const tab = ref(0)
const loading = ref(false)
const filesOrgImage = ref<FileList | null>(null)

const tabs = ref<OrganizationTabsInfo[]>([
  { id: 0, name: 'events' },
  { id: 1, name: 'members' },
  { id: 2, name: 'media' },
  { id: 3, name: 'about' },
])

const currentTab = computed(() => tabs.value[tab.value])

const setCurrentTab = (tabItem: OrganizationTabsInfo) => {
  if (route.query.tab === tabItem.name) {
    isExpansionPanelOpen.value = false
    return
  }
  router.push({
    name: route.name as string,
    params: { id: route.params.id },
    query: { tab: tabItem.name },
    hash: '#org-tabs',
  })
  tab.value = tabItem.id
  isExpansionPanelOpen.value = false
}

const initOrg = async () => {
  const orgData = await fetchOrganization(route.params.id)
  if (!orgData) {
    await store.dispatch('setIsNotFound', true)
    return
  }
  org.value = orgData
}

const initTab = () => {
  if (!route.query.tab) return
  const currentTabItem = tabs.value.find((tabItem) => tabItem.name === route.query.tab)
  if (currentTabItem) tab.value = currentTabItem.id
}

const changeImage = async (event: Event) => {
  if (!org.value || !org.value.canEdit) return
  const input = event.target as HTMLInputElement
  filesOrgImage.value = input.files
  if (!filesOrgImage.value || !filesOrgImage.value.length) return

  const imageId = await saveImage(filesOrgImage.value[0])
  if (!imageId) return

  org.value.image = imageId
  await updateOrganization(org.value)
}

onMounted(async () => {
  await initOrg()
  initTab()
  loading.value = false
})

return { __sfc: true,saveImage, getOrgImage, route, router, org, isExpansionPanelOpen, tab, loading, filesOrgImage, tabs, currentTab, setCurrentTab, initOrg, initTab, changeImage, mdiFacebook, mdiImageOutline, mdiInstagram, mdiLink, mdiTwitter, mdiYoutube, OrganizationAbout, OrganizationEvents, OrganizationMedia, OrganizationMembers }
}

})